import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import MenuIcon from "@mui/icons-material/Menu";
import { PINNACLE_LOGO_URL } from '../../utils/constants';
import { avatarInitials } from '../../utils/avatarInitials';
import { useNavigate } from 'react-router-dom';

// const pages = ['Products', 'Pricing', 'Blog'];
// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const Navbar: React.FC<{ name: string; onOpenSidebar: () => void }> = ({ name, onOpenSidebar }) => {
    const navigate = useNavigate();
    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: 'white',
                color: 'black',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Container maxWidth="xl">
                <Toolbar
                    disableGutters
                    sx={{
                        justifyContent: { xs: 'center', md: 'space-between' },
                        position: 'relative',
                        width: '100%',
                    }}
                >
                    {/* BURGER ICON - visible only on mobile */}
                    <IconButton
                        onClick={onOpenSidebar}
                        sx={{
                            display: { xs: 'flex', md: 'none' },
                            position: 'absolute',
                            left: 0,
                        }}
                    >
                        <MenuIcon />
                    </IconButton>

                    {/* Center Logo */}
                    <Box
                        component="img"
                        src={PINNACLE_LOGO_URL}
                        alt="Logo"
                        sx={{
                            width: 170,
                            height: 'auto',
                            cursor: "pointer"
                        }}
                        onClick={() => navigate('/')}
                    />

                    {/* Desktop Avatar + Name */}
                    <Box
                        sx={{
                            display: { xs: 'none', md: 'flex' },
                            alignItems: 'center',
                            gap: 2.5,
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {name}
                        </Typography>

                        <IconButton sx={{ p: 0 }}>
                            <Avatar {...avatarInitials(name)} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;
